/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturBonusSignIcon20Light = forwardRef('KonturBonusSignIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 1.5a.5.5 0 0 0-1 0V4H6.15A1.15 1.15 0 0 0 5 5.15v9.7c0 .635.515 1.15 1.15 1.15H9v2.5a.5.5 0 0 0 1 0V16h.5a3.5 3.5 0 1 0 0-7H6V5.15A.15.15 0 0 1 6.15 5h6.6a.5.5 0 0 0 0-1H10V1.5ZM6 14.85V10h4.5a2.5 2.5 0 0 1 0 5H6.15a.15.15 0 0 1-.15-.15Z" })));
});
